import { render, staticRenderFns } from "./ArticleLiveBlogHeader.vue?vue&type=template&id=0b346612&scoped=true"
import script from "./ArticleLiveBlogHeader.vue?vue&type=script&lang=ts"
export * from "./ArticleLiveBlogHeader.vue?vue&type=script&lang=ts"
import style0 from "./ArticleLiveBlogHeader.vue?vue&type=style&index=0&id=0b346612&prod&lang=scss&scoped=true"
import style1 from "./ArticleLiveBlogHeader.vue?vue&type=style&index=1&id=0b346612&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b346612",
  null
  
)

export default component.exports